<div class="container">
  <div class="col-md-4 hidden-xs hidden-sm lft-img">
  </div>
  <div class="col-md-8 lgn-main">
    <div class="vertical-center col-md-8">
      <div class="row">
        <div class="col-md-12 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1 center title-border">
          <img src="assets/img/login/Aramex-logo.jpg" height="40" width="260" />
          <h1>{{ 'pages.loginPage.title' | translate}}</h1>
        </div>
      </div>
        <div class="row">
          <div class="col-md-12 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1 center padtop10 lgn-sub">
            <!--<p class="lgn-title">You are not authorized !</p>-->
            <p class="lgn-title line-height">{{ 'pages.loginPage.wlcmMsg' | translate}}</p>
            <!--<p class="lgn-title">Login Page</p>-->
            <!--<p class="lgn-sub">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt</p>-->
          </div>
        </div>
        <!--<div class="form-group col-md-6 col-md-offset-3">
          <label for="exampleInputEmail1">E-mail</label>
          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
        </div>
        <div class="form-group col-md-6 col-md-offset-3">
          <label for="exampleInputPassword1">Password</label>
          <input type="password" class="form-control" id="exampleInputPassword1">
        </div>
        <div class="form-group col-md-6 col-md-offset-3">
          <a routerLink="/dashboard/outlet-selection" class="btn btn-lgn width100">LOGIN</a>
        </div>-->
    </div>
  </div>
</div>
